import { useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { openPrint } from "@/lib/print";
import { Printer } from "lucide-react";

export function useTemplates() {
  return useQuery({ queryKey: ["print-templates"], queryFn: async () => (await api.get("/school/print-templates")).data });
}

// Scales a fixed-size print template to fit its container on screen.
export function Scaled({ scale = 0.6, width, height, children }) {
  return (
    <div style={{ width: `calc(${width} * ${scale})`, height: `calc(${height} * ${scale})`, overflow: "hidden" }}>
      <div style={{ transform: `scale(${scale})`, transformOrigin: "top left", width, height }}>{children}</div>
    </div>
  );
}

// Renders `children` hidden for printing and exposes a print button.
export function PrintButton({ children, title, size, grayscale, label = "Print", testid = "print-btn", className = "ep-btn mt-4 w-full" }) {
  const ref = useRef();
  return (
    <>
      <div ref={ref} style={{ position: "absolute", left: -99999, top: 0 }} aria-hidden>{children}</div>
      <button className={className} onClick={() => openPrint(ref.current.innerHTML, { title, size, grayscale })} data-testid={testid}><Printer size={16} /> {label}</button>
    </>
  );
}
